export function createBackStack(target = window) {
  const layers = [];
  const pop = () => {
    const layer = layers.pop();
    if (layer) layer.close();
  };
  target.addEventListener("popstate", (event) => {
    if (layers.length) {
      event.preventDefault?.();
      pop();
    }
  });
  return {
    get depth() {
      return layers.length;
    },
    push(close) {
      layers.push({ close });
      target.history.pushState({ paws: layers.length }, "");
      return () => this.release(close);
    },
    release(close) {
      const index = layers.findIndex((layer) => layer.close === close);
      if (index < 0) return false;
      layers.splice(index, 1);
      target.history.back();
      return true;
    }
  };
}
